<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">Claim Workflows</p>
      </div>

      <div class="border-b-0.5 flex justify-between items-center pl-0 ml-0 p-2">
        <div class="flex justify-between items-left">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="currentTableData.length"
          >
          </el-pagination>

          <!-- search -->
          <input
            v-model="searchInput"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 py-1 rounded-md"
          />
          <!-- search -->
        </div>
        <div class="flex flex-wrap justify-end w-full gap-3">
          <div
            @click="handleCreateClaimWorkflow"
            class="bg-primary gap-1 flex text-white items-center text-sm px-2 py-1 rounded-md cursor-pointer"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            <p>Create</p>
          </div>
        </div>
      </div>

      <div class="px-2 pt- pb-1 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ del_error }}
          </div>

          <div
            v-if="del_success"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showEditSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showDeptDelSuccess"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_dept }}
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>

        <div>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
          />

          <ve-table
            :columns="columns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No workflows found
          </p>

          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>

        <CompanySetupCreateClaimWorkflow
          :showCreateClaimWorkflow="showCreateClaimWorkflow"
          @close="showCreateClaimWorkflow = false"
          :getWorkflow="getWorkflow"
          :reload="reload"
        ></CompanySetupCreateClaimWorkflow>

        <CompanySetupViewClaimWorkflow
          :showClaimWorkflow="showClaimWorkflow"
          @close="showClaimWorkflow = false"
          :workflowToView="workflowToView"
          :getWorkflow="getWorkflow"
          :reload="reload"
        ></CompanySetupViewClaimWorkflow>

        <!-- edit -->
        <EditClaimWorkflow
          @close="showEditClaimWorkflow = false"
          :workflowToView="workflowToView"
          :info="info"
          :showEditClaimWorkflow="showEditClaimWorkflow"
          :claimWorkflowToEdit="claimWorkflowToEdit"
          :reload="reload"
        >
        </EditClaimWorkflow>

        <ConfirmDelete
          :callback="handleDeleteCallBack"
          :item="workflowName"
          :show-prompt="showDeletePrompt"
        ></ConfirmDelete>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Loader from "@/components/loader/loader.vue";
// import CompanySetupClaimClaimWorkflowUserGroup from "./claimWorkflowUserGroups.vue";
import CompanySetupCreateClaimWorkflow from "./createClaimWorkflow.vue";
import CompanySetupViewClaimWorkflow from "./ClaimWorkflowViewUserGroups.vue";
import { mapGetters } from "vuex";
import EditClaimWorkflow from "../claimWorkflow/editClaimWorkFlow.vue";
import ConfirmDelete from "@/utils/confirmDelete.vue";

export default {
  name: "claimWorkflow",
  components: {
    Loader,
    CompanySetupCreateClaimWorkflow,

    CompanySetupViewClaimWorkflow,
    EditClaimWorkflow,
    ConfirmDelete,
  },
  data() {
    return {
      showEditError: false,
      loading: false,
      selectedOption: "",
      isCheckboxDisabled: false,
      showClaimWorkflowUserGroup: false,
      showEditClaimWorkflow: false,
      showCreateClaimWorkflow: false,
      workflowToCreateWorkflow: null,
      workflowToView: null,
      showClaimWorkflow: false,
      claimWorkflowToEdit: null,
      isBlank: false,
      get_error: null,
      create_success: "Department created successfully",
      del_dept: "Department deleted successfully",
      del_error: null,
      del_success: null,
      showEditSuccess: false,
      showDeptDelSuccess: false,
      searchInput: "",
      workflowToDelete: null,
      title: "",
      message: "",
      workflow: "",
      showWarning: false,
      showDeletePrompt: false,
      workflowName: null,
      info: {
        Sequence1: "",
        Sequence2: "",
        Sequence3: "",
      },
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          title: "Name",
          field: "Name",
          key: "name",

          align: "left",
          renderBodyCell: ({ row }) => {
            return (
              <div on-click={() => this.viewWorkflow(row)}>
                <p class="text-blue-500 cursor-pointer">{row.Name}</p>
              </div>
            );
          },
        },
        {
          title: "Description",
          field: "Description",
          key: "Description",
          headerAlign: "left",
          align: "left",
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement="top-start"
              title={"Claim workflow for " + row.Name}
              width="300"
              trigger="hover"
              content={row.Description}
            >
              <p
                slot="reference"
                class="cursor-pointer"
                styel="font-size: 0.68rem !important;"
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },

        {
          title: "Any Can Approve",
          field: "AnyCanApprove",
          key: "AnyCanApprove",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.AnyCanApprove}></VeCheckbox>
          ),
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.currentTableData;
      } else {
        // Filter the currentTableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getWorkflow(), this.getEmployees(), this.setPageSizes();
  },

  methods: {
    reload() {
      this.getWorkflow();
      this.showCreateClaimWorkflow = false;
    },
    handleCreateClaimWorkflow() {
      this.showCreateClaimWorkflow = true;
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }

      // Add the increment value to each page size in the array
      // for (let i = 0; i < this.pageSizes.length; i++) {
      //   this.pageSizes[i] += pageSizeIncrement;
      // }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },

    viewWorkflow(workflow) {
      console.log(workflow);
      this.workflowToView = workflow;
      this.showClaimWorkflow = true;
      this.$store.commit("setClaimWorkflowToReview", workflow);
    },

    handleDeleteButtonClick(workflow) {
      // Handle the button click for the delete button
      //console.log(workflow);
      this.showDeletePrompt = true;
      this.workflowToDelete = workflow;
      this.workflowName = workflow.Name;
    },

    handleDeleteCallBack() {
      this.showWarning = false;
      this.showDeletePrompt = false;
      this.deleteWorkflow(this.workflowToDelete);
      this.getWorkflow();
    },

    handleEditButtonClick(claimWorkflow) {
      // Handle the button click for the edit button
      //console.log(claimWorkflow);

      this.claimWorkflowToEdit = {
        ClaimWorkflowHeaderId: claimWorkflow.ClaimWorkflowHeaderId,
        Name: claimWorkflow.Name,
        Description: claimWorkflow.Description,
        lines: claimWorkflow.lines,
      };

      this.showEditClaimWorkflow = true;
    },

    // /{organization}/setup/claim/workflow/v1/request
    getWorkflow() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/claim/workflow/${this.$ApiVersion}/request`,

          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              this.tableData = response.data.Data.filter(
                (workflow) => workflow.Name !== "TeSst Workflow"
              );
              //console.log(this.tableData);

              this.loading = false;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;

            setTimeout(() => {
              this.showEditError = false;
            }, 2000);
          }
        );
    },
    // /{organization}/setup/claim/workflow/header/{claimWorkflowHeaderId}/v1/delete
    deleteWorkflow(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/setup/claim/workflow/header/${row.Id}/${this.$ApiVersion}/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.del_success = response.data.StatusMessage;
              this.getWorkflow();
              setTimeout(() => {
                this.del_success = null;
                this.getWorkflow();
              }, 3000);
            } else {
              this.del_error = response.data.StatusMessage;
              setTimeout(() => {
                this.del_error = null;
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
            setTimeout(() => {
              this.del_error = null;
            }, 3000);
          }
        );
    },

    // /{organization}/setup/claim/workflow/header/v1/edit

    // /{organization}/employee/all/v1/request
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$store.commit("setEmployees", response.data.Data);
              this.employees = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>
